import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiTab = {
  styleOverrides: {
    root: ({ theme }) => {
      const isDark = theme.palette.mode === 'dark';
      return {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 1.71,
        minWidth: 'auto',
        paddingLeft: 0,
        paddingRight: 0,
        textTransform: 'none',
        color: isDark ? 'var(--mui-palette-neutral-400)' : 'var(--mui-palette-text-secondary)',
        transition: 'color 160ms ease',
        '& + &': { marginLeft: '24px' },
        '&:hover': {
          color: isDark ? 'var(--mui-palette-neutral-100)' : 'var(--mui-palette-text-primary)',
        },
        '&.Mui-selected': {
          color: 'var(--mui-palette-primary-main)',
          fontWeight: 600,
        },
      };
    },
  },
} satisfies Components<Theme>['MuiTab'];
